// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__1fBjL","sendOtp":"AuthorizeToLogin_sendOtp__xOAug"};